import i18n from 'modules/core/lib/i18n'

import { PeriodScheduleType } from 'modules/work_schedules/lib/forms/PeriodScheduleTypeForm'

export const periodScheduleTypeOptions = () => {
  return [
    {
      value: PeriodScheduleType.flexible,
      label: i18n.t('settings.work_schedule.general_info_section.schedule_type.flexible'),
    },
    {
      value: PeriodScheduleType.fixed,
      label: i18n.t('settings.work_schedule.general_info_section.schedule_type.fixed'),
    },
  ]
}
